import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import FormPartial from './FormPartial.js';
import Offer from '../../models/Offer.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const New = () => {
  const navigate = useNavigate();
  let offerObj = new Offer();
  const [offer, setOffer] = useState(offerObj.toStateJson());
  const [createApi] = getApi('createOffer');

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      toast.success("Offer Created Successfully")
      navigate("/offers")
    } catch (error) {
      offerObj.set_api_errors(error.data.data.errors);
    }
  }

  const handleSubmitFunction = () => {
      try{
        createRecord(new Offer(offer).toApiJson());
      } catch(error){
        setOffer(new Offer(offer));
      }
  }

  const handleCancelFunction = () => {
    navigate('/offers');
  }

  return <PageContentWrapper contentHeading={"Generate New Offer"}>
    <div className='m-3'>
      <div className='mb-4 col-md-12'>
        <form className="row g-3" autoComplete="off">
          <FormPartial offer={offer} setOffer={setOffer} />
          <div className='mb-4 col-md-12'>
            <div >
              <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Create Offer</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </PageContentWrapper>
}

export default New;
